import React from "react";
import { Outlet } from "react-router-dom";
import VaultsTopBar from "../../../Components/VaultsComponents/VaultsTopBar";

const VaultsIndex = () => {
  return (
    <div className="w-full px-4 pt-4" style={{ fontFamily: "General Sans" }}>
      <VaultsTopBar />
      <Outlet />
    </div>
  );
};

export default VaultsIndex;
